import { Component, Input, OnInit } from '@angular/core';

import {
  Permissions,
  UserPermissions,
  hasPermissionForListId,
} from '®shared/permissions';
import { ReadingListDetails } from '®shared/reading-list';
import { getLabelClassForPeriod } from '®shared/tenant/period-label';
import { UriService } from '®shared/url-utils';

@Component({
  selector: 'rl-section-list-details',
  templateUrl: './section-list-details.component.html',
  styleUrls: ['./section-list-details.component.scss'],
})
export class SectionListDetailsComponent implements OnInit {
  @Input() list: ReadingListDetails;
  @Input() permissions: UserPermissions;

  listUrl: string;
  hasEditListPermission: boolean;

  constructor(private uriService: UriService) {}

  ngOnInit(): void {
    this.listUrl = this.uriService.getListViewUrl(this.list.id);
    this.hasEditListPermission = hasPermissionForListId(
      Permissions.EDIT_LIST,
      this.list.id,
      this.permissions,
    );
  }

  get timePeriodLabelClass(): string {
    const { period } = this.list;
    return getLabelClassForPeriod(period);
  }
}
